
function populateCountryCodesSelectContact() {
    const phoneCodesSelect = document.querySelector("#phoneCodesSelect"),
      phoneCode = document.querySelector("#popup_phone_code"),
      bgFlag = document.querySelector(".bg-flag"),
      phoneCodeData = countryPhoneCodes;
      phoneCodeData.forEach(({ code, country, shopifyCode }) => {
        const option = document.createElement("option");
        option.value = code;
        option.textContent = `${country} (${code})`;
        option.setAttribute("data-phone-code", shopifyCode);
        phoneCodesSelect.appendChild(option);
      });

      phoneCodesSelect.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex],
          countryCode = selectedOption.getAttribute("data-phone-code");
          console.log("value changed", selectedOption);
          phoneCode.value = selectedOption.value;
          bgFlag.style.backgroundImage = `url(https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg)`;
      });
    }
    populateCountryCodesSelectContact();


    $(document).ready(function(){
        //If already hide the popup then don't show the modal again
     var closeReopenBtn = sessionStorage.getItem("closeReopenBtn");
          if (closeReopenBtn) {
              $('#reopenPopupBtn').closest('.popupButton-wrap').hide();
              return;
            } 
        setTimeout(function(){
          var showPopup = sessionStorage.getItem("offerPopup");         
          if(showPopup){
            console.log('Popup Already Shown');
            if($('.popup-offer-customer').hasClass('hide')){
            $('.popupButton-wrap').show(); //Show reopen button 
            } 
          } else {
            $('.popup-offer-customer').removeClass('hide');
            $('.email-popup').on('input', function(e) {
                e.preventDefault();
                var inputValue = $(this).val();
                if (inputValue && inputValue.trim().length > 0) {
                    $(this).parent().find('button').prop('disabled', false);
                } else {
                    $(this).parent().find('button').prop('disabled', true);
                }
            });
          }
        },5000);
        $('.close-popup').click(function(){
          sessionStorage.setItem("offerPopup",true);
          $('.popup-offer-customer').addClass('hide');
         $('#reopenPopupBtn').closest('.popupButton-wrap').show(); //Show reopen button
        })

          // Reopen popup
      $('#reopenPopupBtn').click(function(){
          $('.popup-offer-customer').removeClass('hide');
          $(this).closest('.popupButton-wrap').hide(); //  Hide the button again
        });

      $('#closePopupBtn').click(function (e) {
      e.stopPropagation(); // Prevent triggering the reopen button click
      $(this).closest('.popupButton-wrap').hide(); // Hide the entire reopen button
      sessionStorage.setItem("closeReopenBtn", true);
  });
      });


      function validateEmail() {
        const emailInput = document.querySelector('#popup_email');
      
        if (!emailInput) {
            console.error("Email input not found.");
            return false;
        }
      
        const email = emailInput.value.trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        const existingError = emailInput.nextElementSibling;
        if (existingError && existingError.classList.contains('email-error')) {
            existingError.remove();
        }
      
        if (!emailPattern.test(email)) {
            emailInput.style.border = '1px solid red';
            const errorMessage = document.createElement('p');
            errorMessage.textContent = 'Please enter a correct email';
            errorMessage.classList.add('email-error');
            errorMessage.style.color = 'red';
            errorMessage.style.fontSize = '14px';
      
            emailInput.insertAdjacentElement('afterend', errorMessage);
      
            setTimeout(() => {
                emailInput.style.border = '';
                errorMessage.remove();
            }, 2000);
      
            return false;
        }
      
        return true;
      }
      
        function sendCustomerData(event) {
        event.preventDefault();
      
        const container = document.querySelector('.popup-offer-customer');
        if (!container) {
            console.error("Container '.popup-offer-customer' not found.");
            return;
        }
      
        if (!validateEmail()) {
            return; 
        }
      
        const contentForPopup = container.querySelector('.content_for_popup');
        const contentForAlreadySubscribe = container.querySelector('.content_for_popup.already-subscribe');
        const contentForLoader = container.querySelector('.content_for_popup.loader-item');
        const contentForNewSubscribe = container.querySelector('.content_for_popup.new-subscribe');
      
        const email = container.querySelector('#popup_email')?.value.trim();
        const phone = container.querySelector('#popup_phone')?.value.trim();
        const phoneCode = container.querySelector('#popup_phone_code')?.value.trim();
      
        const payload = { email };
      
        if (phone) {
            const fullPhone = phoneCode + phone;
            payload.phone = fullPhone;
        }
      
        contentForPopup.classList.add('hide-item');
        contentForLoader.classList.remove('hide-item');
      
        // console.log("payload for data ====> ", payload);
      
        Shopify.analytics.publish('on_offer_popup_newsletter_subscribe');
        fetch('https://pureflow.pgiproduct.com/api/check-customer-by-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
          if(data.error){
            contentForLoader.classList.add('hide-item');
            contentForPopup.classList.remove('hide-item');
      
            if(data.message.includes("Enter a valid phone number")){
              const phoneInput = container.querySelector('#popup_phone');
              phoneInput.style.border = '1px solid red';
              const errorMessage = document.createElement('p');
              errorMessage.textContent = 'Please enter a valid phone number';
              errorMessage.classList.add('email-error');
              errorMessage.style.color = 'red';
              errorMessage.style.fontSize = '14px';
              errorMessage.style.width = '100%';
              errorMessage.style.marginTop = '5px';
      
              phoneInput.insertAdjacentElement('afterend', errorMessage);
      
              setTimeout(() => {
                  phoneInput.style.border = '';
                  errorMessage.remove();
              }, 2000);
      
            }
            else if(data.message.includes("Phone has already been taken")){
              const phoneInput = container.querySelector('#popup_phone');
              phoneInput.style.border = '1px solid red';
              const errorMessage = document.createElement('p');
              errorMessage.textContent = 'Phone has already been taken';
              errorMessage.classList.add('email-error');
              errorMessage.style.color = 'red';
              errorMessage.style.fontSize = '14px';
              errorMessage.style.width = '100%';
              errorMessage.style.marginTop = '5px';
      
              phoneInput.insertAdjacentElement('afterend', errorMessage);
      
              setTimeout(() => {
                phoneInput.style.border = '';
                  errorMessage.remove();
              }, 2000);
            }
      
          }
          if(data.status == "updated"){
            contentForLoader.classList.add('hide-item');
            contentForAlreadySubscribe.classList.remove('hide-item');
            setTimeout(function(){
              sessionStorage.setItem("offerPopup",true);
              $('.popup-offer-customer').addClass('hide');
            }, 3000);
          }
          else if(data.status == "new"){
            contentForLoader.classList.add('hide-item');
            contentForNewSubscribe.classList.remove('hide-item');
            setTimeout(function(){
              sessionStorage.setItem("offerPopup",true);
              $('.popup-offer-customer').addClass('hide');
            }, 3000);
          }
        })
        .catch(error => console.error("Error:", error));
        }
      
        const subscribeBtn = document.querySelector('#popup_submit');
        if (subscribeBtn) {
          subscribeBtn.addEventListener('click', sendCustomerData);
        }